var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCreateWatchroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8998 7.21569C18.7928 7.21569 20.4213 5.66626 20.4213 3.64854C20.4213 1.65519 18.7842 0.178436 16.8998 0.178436C15.0158 0.178436 13.3782 1.6874 13.3782 3.66465C13.3782 5.66626 15.0068 7.21569 16.8998 7.21569ZM6.7662 7.40151C8.40377 7.40151 9.83049 6.04537 9.83049 4.29401C9.83049 2.55915 8.39477 1.27569 6.7662 1.27569C5.12906 1.27569 3.68477 2.59136 3.69377 4.31051C3.69377 6.04536 5.12006 7.40151 6.76663 7.40151M1.85391 14.689H8.54477C7.62934 13.4704 8.74749 11.017 10.6405 9.67733C9.66334 9.08019 8.40377 8.63626 6.75763 8.63626C2.78691 8.63587 0.304199 11.323 0.304199 13.5588C0.304199 14.2855 0.744342 14.689 1.85391 14.689ZM11.3622 14.689H22.4288C23.8109 14.689 24.3042 14.3256 24.3042 13.6153C24.3042 11.5332 21.4602 8.66022 16.8912 8.66022C12.3308 8.66022 9.48677 11.5332 9.48677 13.6157C9.48677 14.3256 9.97963 14.689 11.3622 14.689Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreateWatchroom);
export default __webpack_public_path__ + "static/media/ic_create_watchroom.735942383751d586731d14b2fa6bacec.svg";
export { ForwardRef as ReactComponent };